import React, { useEffect, useState } from "react";
import Select from 'react-select';
import { styleSelect } from "../../../constants/customStyles";
import { useDispatch, useSelector } from "react-redux";
import { savePoliceReport } from "../../../actions/PoliceReportActions";
import Toast from "../../../components/Toast";
import { getAllPoliceStation } from "../../../actions/PoliceStationActions";


function PoliceReportModal() {
    const dispatch = useDispatch();

    const [reportNo, setReportNo] = useState('');
    const [policeId, setPoliceId] = useState('');
    const [location, setLocation] = useState('');
    const [date, setDate] = useState('');
    const [time, setTime] = useState('');

    useEffect(() => {
            dispatch(getAllPoliceStation(null, '', ''));
         }, []);

    const policeStations = useSelector(state => state?.police?.allPolice?.data);

    const save = () => {
        if (reportNo.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Report Number is Required!'
            })
        } else if (policeId.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Police is Required!'
            })
        } else if (location.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Location is Required!'
            })
        } else if (date.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Date is Required!'
            })
        } else if (time.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Time is Required!'
            })
        } else {
            let data = {
                report_no: reportNo,
                police_id: policeId,
                location: location,
                date: date,
                time: time,
            }
            dispatch(savePoliceReport(data));
        }
    }

    return (
        <React.Fragment>
            {/* Edit Police Report Modal */}
            <div id="police-report-modal" className="modal fade" tabindex="-1" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div className="modal-header">
                            <h2 className="fw-medium fs-base me-auto">Police Report</h2>
                        </div>
                        {/* </div> <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="modal-body">
                            <form>
                                <div className="grid columns-12">
                                    <div className="intro-y g-col-6">
                                        <label for="report_no" className="form-label">Report No. :</label>
                                        <input id="report_no" onChange={(e) => setReportNo(e.target.value)} name="report_no" type="text" required className="form-control" placeholder="Enter Report No." />
                                    </div>
                                    <div className="intro-y g-col-6">
                                        <label for="police" className="form-label">Police :</label>
                                        <Select styles={styleSelect} onChange={(e) => setPoliceId(e.police_station_id)} getOptionLabel={(option) => `${option.name}`} getOptionValue={(option) => `${option.police_station_id}`} options={policeStations && policeStations.length > 0 ? policeStations : []} />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-12">
                                        <label for="location" className="form-label">Location :</label>
                                        <input id="location" name="location" onChange={(e) => setLocation(e.target.value)} type="text" required className="form-control" placeholder="Enter Location" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="date" className="form-label">Date :</label>
                                        <input id="date" name="date" onChange={(e) => setDate(e.target.value)} type="date" className="form-control" placeholder="Enter Date" />
                                    </div>
                                    <div className="intro-y g-col-12 g-col-sm-6">
                                        <label for="time" className="form-label">Time :</label>
                                        <input id="time" name="time" onChange={(e) => setTime(e.target.value)} type="time" className="form-control" placeholder="Enter Time" />
                                    </div>
                                    <div className="intro-y g-col-12">
                                        <label for="image" className="form-label">Image:</label>
                                        <div className="dropzone text-center pt-10">
                                            <div className="fallback ms-5"> <input name="file" type="file" multiple /> </div>
                                            <div className="dz-message mt-3" data-dz-message>
                                                <div className="fs-lg fw-medium">Drop files here or click to upload.</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div className="modal-footer text-end"> <button type="button" data-bs-dismiss="modal" className="btn btn-outline-secondary w-20 me-1">Cancel</button> <button onClick={save} data-bs-dismiss="modal" type="button" className="btn btn-primary w-20">Submit</button> </div>
                    </div>
                </div>
            </div>
            {/*End Edit Police Report Modal */}
        </React.Fragment>
    )
}

export default PoliceReportModal;
